import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../hooks';

import { PerformanceReviewActions } from '../actions/performance-review/performance-review.actions';

import type { PerformanceReview } from '../interfaces/employee/performance-review.interface';

import HrDocumentLocker from './HrDocumentLocker';

// Performance reviews (PDRs).  Note the API emits `employee_id` here where
// payslips and IRP5s emit `user_id` for the same thing — the locker accepts
// either, so no mapping is needed at this layer.
const PerformanceReviewsListV3 = () => {
  const dispatch = useAppDispatch();
  const reviews: PerformanceReview[] =
    useAppSelector(({ performance_review_store }) => performance_review_store.performanceReviews) ||
    [];
  const [loaded, setLoaded] = useState(reviews.length > 0);

  useEffect(() => {
    dispatch(PerformanceReviewActions.loadPerformanceReviews(() => setLoaded(true)));
  }, [dispatch]);

  return (
    <HrDocumentLocker
      title="Performance reviews"
      eyebrow="Human Resources"
      noun="review"
      records={reviews}
      loaded={loaded}
      legacyAddPath="/human-resources/performance-reviews/add"
      legacyEditPath={(id) => `/human-resources/performance-reviews/${id}`}
    />
  );
};

export default PerformanceReviewsListV3;
